import { useEffect, useState } from 'react'

import { card, sticker } from '../../testdata'
import Card from './Card'
import { SpecialCard } from './SpecialCard'

const CollectionDisplay = ({ civilization, cards, stickers }) => {
  const [card, setCard] = useState(false)

  useEffect(() => {
    if (cards) setCard(true)
    console.log('collectionViewer:', cards)
  }, [cards])

  return (
    <>
      <div className="flex flex-row flex-wrap w-full justify-evenly gap-3 collection-wrapper">
        <>
          {card ? (
            cards.map((card, _) => (
              <Card
                key={_}
                // id={id}
                image={card.image}
                video={card.video}
                name={card.name}
                notInUserWallet={card.notInUserWallet}
                bestRarity={card.bestRarity}
                mp={card.mp}
                rarities={[
                  {
                    name: 'Tit',
                    quantity: card.info.Titanium
                      ? card.info.Titanium.quantity
                      : 0,
                    mp: card.info.Titanium
                      ? card.info.Titanium.mp * card.info.Titanium.quantity
                      : 0,
                  },
                  {
                    name: 'Met',
                    quantity: card.info.Meteorite
                      ? card.info.Meteorite.quantity
                      : 0,
                    mp: card.info.Meteorite
                      ? card.info.Meteorite.mp * card.info.Meteorite.quantity
                      : 0,
                  },
                  {
                    name: 'Bes',
                    quantity: card.info.Beskar ? card.info.Beskar.quantity : 0,
                    mp: card.info.Meteorite
                      ? card.info.Meteorite.mp * card.info.Meteorite.quantity
                      : 0,
                  },
                  {
                    name: 'Chr',
                    quantity: card.info.Chromium
                      ? card.info.Chromium.quantity
                      : 0,
                    mp: card.info.Chromium
                      ? card.info.Chromium.mp * card.info.Chromium.quantity
                      : 0,
                  },
                  {
                    name: 'Pla',
                    quantity: card.info.Plasma ? card.info.Plasma.quantity : 0,
                    mp: card.info.Plasma
                      ? card.info.Plasma.mp * card.info.Plasma.quantity
                      : 0,
                  },
                  {
                    name: 'Lum',
                    quantity: card.info.Luminaya
                      ? card.info.Luminaya.quantity
                      : 0,
                    mp: card.info.Luminaya
                      ? card.info.Luminaya.mp * card.info.Luminaya.quantity
                      : 0,
                  },

                  {
                    name: 'Uni',
                    quantity: card.info.Unicorn
                      ? card.info.Unicorn.quantity
                      : 0,
                    mp: card.info.Unicorn
                      ? card.info.Unicorn.mp * card.info.Unicorn.quantity
                      : 0,
                  },
                  {
                    name: 'Sup',
                    quantity: card.info.Supernova
                      ? card.info.Supernova.quantity
                      : 0,
                    mp: card.info.Supernova
                      ? card.info.Supernova.mp * card.info.Supernova.quantity
                      : 0,
                  },
                  {
                    name: 'Gol',
                    quantity: card.info.Goldstorm
                      ? card.info.Goldstorm.quantity
                      : 0,
                    mp: card.info.Goldstorm
                      ? card.info.Goldstorm.mp * card.info.Goldstorm.quantity
                      : 0,
                  },
                ]}
              />
            ))
          ) : (
            <span className="text-gold">Waiting</span>
          )}
        </>
      </div>
      <>
        <h3 className="uppercase text-gold pt-10 pb-6">Stickers</h3>
        <div className="md:grid flex flex-col w-full gap-10 stickers-collection-wrapper pb-10">
          <>
            {stickers // Static data
              ? stickers.map((sticker, i) => (
                  <SpecialCard
                    key={`${i}-${civilization}`}
                    name={sticker.name}
                    image={sticker.card.image}
                    video={sticker.card.video}
                    quantity={sticker.card.quantity}
                    notInUserWallet={!sticker.card.quantity}
                    mp={sticker.card.mp}
                  />
                ))
              : (
                <span className="text-gold">Waiting</span>
              )}
          </>
        </div>
      </>
    </>
  )
}

export default CollectionDisplay
